import { Block, Flex } from '@aloft/toolkit-sui';

import React from 'react';

import { PropertyGrid } from '../../components/PropertyGrid/PropertyGrid.tsx';
import { useTkv2ReferenceBarEvents } from '../../components/ReferenceBar/useTkv2ReferenceBarEvents.ts';
import { AdjustmentsGridAdjustedSPSection } from './columnSections/AdjustmentsGridAdjustedSPSection.tsx';
import { AdjustmentsGridDateOfSaleSection } from './columnSections/AdjustmentsGridDateOfSaleSection.tsx';
import { AdjustmentsGridDepreciatedCostSection } from './columnSections/AdjustmentsGridDepreciatedCostSection.tsx';
import { AdjustmentsGridSiteExtractionSection } from './columnSections/AdjustmentsGridSiteExtractionSection.tsx';
import { AdjustmentsModuleTitle } from '../adjustments/internal/AdjustmentsModuleTitle.tsx';

export const AdjustmentsGridModule = React.memo(() => (
  <Flex
    {...useTkv2ReferenceBarEvents()}
    flexDirection="column"
    overflow="hidden"
    width="100%"
    gap={2}
  >
    <Block margin="10px 20px 0 10px">
      <AdjustmentsModuleTitle />
    </Block>
    <Block overflow="auto">
      <PropertyGrid
        gridType="AdjustmentsGrid"
        columnSections={[
          AdjustmentsGridDateOfSaleSection,
          AdjustmentsGridSiteExtractionSection,
          AdjustmentsGridDepreciatedCostSection,
          AdjustmentsGridAdjustedSPSection,
        ]}
      />
    </Block>
  </Flex>
));
